







































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { professionServer, roleServe, userServe } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
@Component({
  components: { PagingUnit, CollapseTransition, TreeUnit },
  mixins: [TableStripe],
})
export default class User extends Vue {
  @Prop(Object) page!: any; // 从父组件接受过来一行的数据
  oneColumnType = 'index'; // 决定第一列是索引还是选择
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  openFlag = true; // 控制左侧导航栏是否显示
  // 树形图的数组
  defaultProps: object = {
    children: 'children',
    label: 'label',
  };
  searchFlag = false; // 控制显示查询和隐藏查询
  // moreFlag = false; // 控制显示更多搜索框
  organDialogVisible = false; // 弹出框是否显示
  dialogTitle = ''; // 公司机构弹框标题
  checkNode: any = {}; // 选中的节点数据
  searchOrgan = ''; // 搜索机构需要的数据
  // 树形图的数据
  treeData: Array<any> = [];
  total = 1000; // 数据总共多少条
  openTreeFlag = false; // 树是否打开
  // 搜索栏的数据对象
  searchFormData: object = {
    search: '',
    workStatus: '',
    organ: '', // 机构
    company: '', // 公司
    email: '', // 邮箱
    station: '', // 岗位
    companyPhone: '', //公司电话
    role: '', // 角色
  };
  // 搜索栏的中间控制数据对象：当没有点 查询按钮时，这个值不会变
  pageSearchData: object = {};
  // 表格的数据对象
  tableData: Array<any> = [];
  professionData: Array<any> = [];
  roleData: Array<any> = [];

  get orgList() {
    return this.$store.state.user.orgList;
  }

  showTree(flag: boolean) {
    this.openFlag = flag;
  }

  getNodeIds(data: any) {
    (this.queryDataForm as any).pageNo = 1;
    // this.getAllData({})
    this.getListData();
  }

  getPostlist(data: any) {
    const newList: any = [];
    data.forEach((res: any) => {
      newList.push(res.postName);
    });
    return newList.join('、');
  }

  // Vue创建数据声明周期钩子函数
  created() {
    this.queryDataForm = this.page;
    // setTimeout(()=>{
    // console.log(this.orgList);
    // },2000)
    // this.getPageData();
    this.getRoleDataList();
    // 初始化 table 数据
    this.getAllData({ current: (this.queryDataForm as any).pageNo, size: (this.queryDataForm as any).pageSize });
    // 初始化树形图 treeData 数据
    // institutionServer
    //   .getAllData({})
    //   .then((res: any) => {
    //     if (res.code === '200') {
    //       this.treeData = arrayToTree(res.data); // 将得到的数据处理后赋给树形图数据
    //     }
    //   })
    //   .catch(() => {
    //     this.$message.error('初始化树形图数据失败!');
    //   });
  }

  orgIdToName(id: any) {
    // console.log(id);
    // console.log(this.orgList);
    const a: any = this.orgList.find((s: any) => {
      return s.spaceId === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  /**
   * @desc 获取所有岗位数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    professionServer
      .getPageData({})
      .then((res: any) => {
        this.professionData = res.data.records;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取所有角色数据
   * @param1 暂无
   * @returns 暂无
   */
  private getRoleDataList() {
    // 发起接口请求，获取分页数据
    roleServe
      // .getRoleDataList({})
      .getRoleDataListAll({})
      .then((res: any) => {
        this.roleData = res.data.records;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  //  todo 抽出公共方法
  // private tableRowClassName({ row, rowIndex }: any) {
  //   if (rowIndex % 2 == 0) {
  //     return 'stripe-row-my';
  //   } else {
  //     return '';
  //   }
  // }

  handleNodeClickToList(data: any) {
    // 取消被选中的 树节点。
    (this.$refs.treeRef as any).store._getAllNodes().forEach((item: any, i: number) => {
      if (item.data !== data) {
        (this.$refs.treeRef as any).getNode(item.data.id).isCurrent = false;
      }
    });
    (this.searchFormData as any).deptId = data.id;
    this.searchData(); // 发起搜索
  }

  /**
   * @desc 获取所有符合条件的数据
   * @param1 opts: 要筛选的条件对象
   * @returns 暂无
   */
  getAllData(opts: object) {
    userServe
      .getPageData(opts)
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records; // 表单得到数据渲染
          this.total = res.data.total; // 获得到总共条数
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败,请稍后重试!');
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    this.getAllData({ ...this.pageSearchData, current: (this.queryDataForm as any).pageNo, size: (this.queryDataForm as any).pageSize });
  }

  /**
   * @desc 通过表单查询符合条件的 table 数据
   * @param1 暂无
   * @returns 暂无
   */
  searchData() {
    // 遍历表单搜索数据
    for (const key in this.searchFormData) {
      if ((this.searchFormData as any)[key]) {
        // 如果搜索表单里面的这一项有值，那么就加入到 分页搜索数据中
        (this.pageSearchData as any)[key] = (this.searchFormData as any)[key];
      }
    }
    // 将 page 分页的页数重置为 1
    (this.queryDataForm as any).pageNo = 1;
    this.getListData(); // 获取到符合条件的分页数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 切换左侧导航栏是否显示
   * @param1 暂无
   * @returns 暂无
   */
  toggleOpen() {
    this.openFlag = !this.openFlag;
  }
  /**
   * @todo 后期需要优化的部分
   * @desc 点击归属机构 input ，打开 归属机构的 dialog
   * @param1 name: dialog 弹框名称。
   * @param2 data: 归属机构的内容
   * @returns 暂无
   */
  openOrganDialog(name: string, data: string): void {
    this.dialogTitle = name; // dialog 标题
    this.checkNode.label = data; // 打开归属机构的dialog 让选中节点是data;
    this.organDialogVisible = true;
    Vue.nextTick(() => {
      (this.$refs.searchOrganRef as any).focus();
      // 打开被选中的树
      this.openCheckedTree(this.treeData, data);
      // 打开一层目录
      this.treeData.forEach(item => {
        (this.$refs.dialogTreeRef as any).getNode(item.id).expanded = true;
      });
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc dialog 弹出框中的确定按钮点击事件，点击修改搜索内容
   * @param1 暂无
   * @returns 暂无
   */
  submitOrgan(): void {
    if (this.dialogTitle === '机构选择') {
      (this.searchFormData as any).deptId = this.checkNode.id; // 查询现在有问题，后续再看，目前没时间
    } else {
      (this.searchFormData as any).spaceId = this.checkNode.id; // 查询现在有问题，后续再看，目前没时间
    }
    this.organDialogVisible = false; // 关闭归属机构的 dialog
  }

  /**
   * @todo 后期需要优化的部分
   * @desc  关闭归属机构的 dialog
   * @param1 暂无
   * @returns 暂无
   */
  closeOrganDialog(): void {
    this.searchOrgan = '';
    this.checkNode = {}; // 将选中的节点数据清空
    this.organDialogVisible = false;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击 dialog 中的清除按钮，清除内容。
   * @param1 暂无
   * @returns 暂无
   */
  clearOrgan(): void {
    if (this.dialogTitle === '机构选择') {
      (this.searchFormData as any).organ = '';
    } else {
      (this.searchFormData as any).company = '';
    }
    this.organDialogVisible = false;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击附属机构 input 触发事件，打开被选中的树节点。
   * @param1 tree: 树节点对象
   * @param2 name: 用于进行判断的名称
   * @returns 返回值描述
   */
  openCheckedTree(tree: any, name: string) {
    tree.forEach((item: any) => {
      if (item.label === name) {
        (this.$refs.dialogTreeRef as any).getNode(item.id).isCurrent = true;
        (this.$refs.dialogTreeRef as any).getNode(item.id).parent.expanded = true;
      } else if (item.children) {
        this.openCheckedTree(item.children, name);
      }
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 每次点击树节点都会触发的事件，获得当前点击的id
   * @param1 data: 被点击的节点数据对象
   * @returns 暂无
   */
  handleNodeClick(data: any) {
    // 取消被选中的 树节点。
    (this.$refs.dialogTreeRef as any).store._getAllNodes().forEach((item: any, i: number) => {
      if (item.data !== data) {
        (this.$refs.dialogTreeRef as any).getNode(item.data.id).isCurrent = false;
      }
    });
    this.checkNode = data; // 选中的节点数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮会触发事件，用于显示和隐藏搜索栏
   * @param1 暂无
   * @returns 暂无
   */
  hideSearch(): void {
    this.searchFlag = !this.searchFlag;
  }
  /**
   * @todo 后期需要优化的部分
   * @desc 重置搜索的表单
   * @param1 暂无
   * @returns 暂无
   */
  resetSearch(): void {
    (this.$refs.formRef as any).resetFields(); // 重置表单内容
    this.pageSearchData = {}; // 重置表单搜索的数据
    this.searchFormData = {}; // 重置表单搜索的数据
    (this.queryDataForm as any).pageNo = 1; // page 变为第一页 size 不变
    this.getListData(); // 获取到全部数据
  }
  /**
   * @todo 后期需要优化的部分
   * @desc 新增按钮点击跳转到其他页面,并且修改 row 为 空对象。
   * @param1 暂无
   * @returns 暂无
   */
  addNew(): void {
    this.$emit('update:setRoleFlag', true); // 将分配角色显示出来
    this.$emit('setRow', { otherOrgan: [] });
    this.$emit('update:flag', 2);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击登录账号和编辑按钮 跳转到编辑用户
   * @param1 暂无
   * @returns 暂无
   */
  editUser(row: object): void {
    this.$emit('update:setRoleFlag', false);
    // 这一步为了让 otherOrgan 是一个数组,一旦连接接口就需要删掉.
    (row as any).otherOrgan = [];
    this.$emit('setRow', row);
    this.$emit('update:flag', 2);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 停用用户
   * @param1 暂无
   * @returns 暂无
   */
  // stopUser(): void {
  //   this.$confirm('确认要停用该用户吗？', '信息', {
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     type: 'warning',
  //     customClass: 'box--msg',
  //   })
  //     .then(() => {
  //       this.$message({
  //         type: 'success',
  //         message: '停用成功!',
  //       });
  //     })
  //     .catch(() => {
  //       this.$message({
  //         type: 'info',
  //         message: '已取消停用',
  //       });
  //     });
  // }

  /**
   * @todo 后期需要优化的部分
   * @desc  删除用户
   * @param1 暂无
   * @returns 暂无
   */
  deleteUser(id: string): void {
    this.$confirm('确认要删除该用户吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        userServe
          .deleteData(id)
          .then((res: any) => {
            if (res.code === '200') {
              if (this.total % (this.queryDataForm as any).pageSize === 1 && (this.queryDataForm as any).pageNo !== 1) {
                (this.queryDataForm as any).pageNo--;
              }
              this.$message.success('删除成功!');
              this.getListData(); // 获取到符合条件的数据
            }
          })
          .catch(() => {
            this.$message.error('删除用户失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 跳转到分配角色页面
   * @param1 id: 用户的id
   * @returns 暂无
   */
  setRole(row: object): void {
    this.$emit('setRoleData', { row: row, flag: true }); // 调用父组件的自定义事件，将row传递过去
    this.$emit('update:flag', 3);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 跳转到设置用户数据权限界面,并将数据传递过去
   * @param1 id：传递该用户id
   * @returns 暂无
   */
  setPower(row: object): void {
    this.$emit('setRoleData', { row: row, flag: false }); // 调用父组件自定义事件，将row传递过去s
    this.$emit('update:flag', 3);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 提示是否重置密码到初始状态
   * @param1 id: 用户 id
   * @returns 暂无
   */
  resetPsd() {
    this.$confirm('确认要将该用户密码重置到初始状态吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'reset--psd box--msg',
    })
      .then(() => {
        this.$message({
          type: 'success',
          message: '重置成功!',
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置',
        });
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 状态的计算属性，如果状态是 1 则是正常 ,2 停用, 3 冻结
   * @param1 传入用户的 state 状态值
   * @returns 计算属性返回一个函数可以来传参，函数进行判断。
   */
  // get setUserState(): object {
  //   return (state: string): string => {
  //     if (state === '在职') {
  //       return '在职';
  //     } else {
  //       return '离职';
  //     }
  //   };
  // }
  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性：判断用户状态从而给出状态按钮背景颜色。
   * @param1 传入用户的 state 状态值
   * @returns 返回一个函数，用于传递参数和判断状态按钮背景颜色。
   */
  get setStateColor(): object {
    return (state: string): string => {
      if (state === '在职') {
        return 'tag-green';
      } else {
        return 'tag-red';
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 切换数据树状态，全部打开或者全部关闭。
   * @param1 暂无
   * @returns 暂无
   */
  changeTreeState(): void {
    this.openTreeFlag = !this.openTreeFlag;
    (this.$refs.treeRef as any).store._getAllNodes().forEach((val: any, i: number) => {
      if (this.openTreeFlag) {
        val.expanded = true;
      } else {
        val.expanded = false;
      }
    });
  }

  // dom 挂载完成阶段
  mounted(): void {
    setTimeout(() => {
      this.$store.commit('changePageLoading', false);
      // console.log(this.$store.state);
    }, 3000);
    // 打开数据树所有一级目录
    this.treeData.forEach(item => {
      (this.$refs.treeRef as any).getNode(item.id).expanded = true;
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性，判断table的该项是否添加 fixed
   * @param1 暂无
   * @returns  返回一个函数来进行传值
   */
  get setFixed() {
    return (label: string) => {
      if (label === '登录账号') {
        return true;
      } else if (label === '操作') {
        return 'right';
      } else {
        return false;
      }
    };
  }
}
